// @flow

// Vendors
import React from 'react';

// Types
type Props = {
  filters: { keywords: string, location: string },
  locations: Array<{ label: string, value: string }>,
  handleFilterChange: Function,
  resetFilter: Function,
  labelSearch: string,
  labelLocation: string
};

const SmartBidBidsFilters = ({
  filters,
  locations,
  handleFilterChange,
  resetFilter,
  labelSearch,
  labelLocation
}: Props) => (
  <form className="filters">
    <div className="filters__search-field form__field">
      <input
        className="form__input"
        type="text"
        name="keywords"
        value={filters.keywords}
        onChange={handleFilterChange}
        placeholder={labelSearch}
      />
      {filters.keywords && (
        <button
          type="button"
          className="form__field__clear"
          onClick={() => resetFilter('keywords')}
        />
      )}
    </div>
    <div className="filters__locations-field form__field">
      <div className="form__select">
        <select
          className="form__input"
          name="location"
          value={filters.location}
          onChange={handleFilterChange}
        >
          <option value="">{labelLocation}</option>
          {locations.map(({ value, label }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        {filters.location && (
          <button
            type="button"
            className="form__field__clear"
            onClick={() => resetFilter('location')}
          />
        )}
      </div>
    </div>
  </form>
);

SmartBidBidsFilters.defaultProps = {
  labelSearch: 'Search Keywords',
  labelLocation: 'Select a Location'
};

export default SmartBidBidsFilters;
